import { Dropdown, Menu } from 'antd';
import React from 'react';
import DokanIcons from '../icon/DokanIcons';

const DokanItemDateFilter = () => (
    <Dropdown
        overlay={
            <Menu>
                <Menu.Item>
                    <a target="_blank" rel="noreferrer" href="http://www.alipay.com/">
                        This Week
                    </a>
                </Menu.Item>
                <Menu.Item>
                    <a target="_blank" rel="noreferrer" href="http://www.taobao.com/">
                        This Month
                    </a>
                </Menu.Item>
                <Menu.Item>
                    <a target="_blank" rel="noreferrer" href="http://www.tmall.com/">
                        This Year
                    </a>
                </Menu.Item>
            </Menu>
        }
        placement="bottomCenter"
        arrow
    >
        <button className="pl-35px focus:outline-none" type="button">
            <div className="filter-button">
                <p className="mr-10px text-secondary">
                    All <span className="text-base font-medium">Date</span>
                </p>
                <DokanIcons icon="#carrotDown" size={2} />{' '}
            </div>
        </button>
    </Dropdown>
);

export default DokanItemDateFilter;
